import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const DEFAULT_LANG = process.env.VUE_APP_DEFAULT_LANG

const store = new Vuex.Store({
    state: {
        lang: DEFAULT_LANG,
        otpTimeout: 60,
        profile: {
            username: '',
            name: '',
            phoneNumber: '',
            profilePicture: '',
            referralCode: '',
            password: '',
            otp: ''
        }
    },
    getters: {
        completedProfile (state) {
            const profile = state.profile

            if (!profile) {
                return false
            }

            const keys = ['username', 'phoneNumber', 'password']

            for (let i = 0; i < keys.length; i++) {
                if (!Object.prototype.hasOwnProperty.call(profile, keys[i])) {
                    return false
                }

                if (profile[keys[i]].trim().length === 0) {
                    return false
                }
            }

            return true
        }
    },
    mutations: {
        SET_LANGUAGE (state, lang) {
            state.lang = lang
        },
        SET_USERNAME (state, username) {
            state.profile.username = username
        },
        SET_NAME (state, name) {
            state.profile.name = name
        },
        SET_PHONE (state, phone) {
            state.profile.phoneNumber = phone
        },
        SET_PASSWORD (state, password) {
            state.profile.password = password
        },
        SET_REFERRAL (state, referral) {
            state.profile.referralCode = referral
        },
        SET_OTP_TIMEOUT (state, timeout) {
            state.otpTimeout = timeout
        },
        SET_OTP (state, otp) {
            state.profile.otp = otp
        }
    },
    actions: {
        changeLanguage ({ commit }, lang) {
            commit('SET_LANGUAGE', lang || DEFAULT_LANG)
        },
        setUsername ({ commit }, username) {
            commit('SET_USERNAME', username)
        },
        setName ({ commit }, name) {
            commit('SET_NAME', name)
        },
        setPhone ({ commit }, phone) {
            commit('SET_PHONE', phone)
        },
        setPassword ({ commit }, password) {
            commit('SET_PASSWORD', password)
        },
        setReferral ({ commit }, referral) {
            commit('SET_REFERRAL', referral)
        },
        setOTPTimeout ({ commit }, timeout) {
            commit('SET_OTP_TIMEOUT', timeout)
        },
        setOTP ({ commit }, otp) {
            commit('SET_OTP', otp)
        }
    }
})

export default store
